export default __webpack_public_path__ + "static/media/liberty.77be6c0a.svg";